import {Subject} from "rxjs";
import {DokumentId, Modelloppdatering, MøtedeltakerId, MøteId} from "../ressurser/generertNg2HttpKlient";
import {InjectionToken} from "@angular/core";

/** Definerer metoder fra ajs {@link ModelloppdateringTjeneste} som vi benytter i ng2-koden */
export interface AjsModelloppdateringTjeneste {

    get hendelser(): Subject<Modelloppdatering<any>>;

    broadcastLokalNyttMøte(møteId: MøteId): void;

    broadcastLokalSignatarSignert(dokumentId: DokumentId): void;

    broadcastLokalMøtedeltakerOppdatert(deltakerId: MøtedeltakerId, møteId: MøteId): void;

    broadcastLokalModellOppdatert(eventId: string, modell: any): void;
}

export const ajs_ModelloppdateringTjeneste_DI_TOKEN = new InjectionToken<AjsModelloppdateringTjeneste>('ajs ModelloppdateringTjeneste');
